<template>
<div class="container">
    <h3 class="fw-bold">Pending Account Issues</h3> 
    <ul class="list-inline p-2">
            <li class="list-inline-item">Name: {{full_name}} | </li>
            <li class="list-inline-item">Level: {{role}} | </li>
            <li class="list-inline-item">Expiry: {{end_date}} | </li>  
            <li class="list-inline-item">Customer Program Number: {{customer_program_no}} </li>          
    </ul> 
    <p class="fw-bold">Unfortunately, you cannot delete your account at this time due to the following:</p> 
    <ul class="list-unstyled">
      <li class="p-1 text-muted" v-for="item in errors">
       {{ item}}
      </li>
    </ul>
    <p class="fw-bold">All pending issues need to be resolved before your account can be deleted. If you think there has been a mistake or would like to discuss further, please email <a href="mailto:contact@huntergold.com" target="_blank" class="link-dark">contact@huntergold.com</a>. Please include your Hunter & Gold account details, as shown above, in any correspondence.</p>      
    <div>
      <button class="btn btn-md btn-dark" @click="ok">Exit</button>
    </div>
</div>

</template>
<script>

export default {
  name: 'DeleteNotAllowed',

  props: ["data"],

  data() {
    return {
      full_name: this.data.name,
      role: this.data.role,
      end_date: this.data.role_end_date,
      customer_program_no: this.data.customer_program_no,
      errors: this.data.errors,
    };
  },

  methods: {
    ok() {
      if (localStorage.getItem("token") != null)
        localStorage.removeItem("token")

      this.$router.go('/');
    }
  }
}
</script>
<style scoped>
button { margin: 5px 5px 5px 5px } 
.btn-danger, .btn-danger:hover, .btn-danger:active, .btn-danger:visited {
    background-color:#EC1C24 !important;
}

option:before {
  white-space: break-spaces;
}
</style>
